import React from 'react'

const NoDataRow = () => {
  return (
    <tr className='text-center'><td colSpan={20}>No Data found</td></tr>
  )
}

export default NoDataRow